module.exports = __webpack_public_path__ + "img/telegram.209fc2f0.svg";